import React from 'react';
import { useTranslation } from 'react-i18next';
import { Search, Clock, TrendingUp } from 'lucide-react';

interface SearchResultsHeaderProps {
  searchQuery: string;
  resultCount: number;
  searchTime?: number;
}

export const SearchResultsHeader: React.FC<SearchResultsHeaderProps> = ({
  searchQuery,
  resultCount,
  searchTime
}) => {
  const { t } = useTranslation();

  return (
    <div className="text-center py-8 bg-gradient-to-r from-primary-50 to-blue-50 dark:from-primary-900/20 dark:to-blue-900/20 rounded-2xl border border-primary-100 dark:border-primary-800/30">
      <div className="flex justify-center mb-4">
        <div className="p-3 bg-primary-100 dark:bg-primary-900/30 rounded-full">
          <Search className="w-8 h-8 text-primary-600 dark:text-primary-400" />
        </div>
      </div>
      
      <h2 className="text-3xl font-bold text-gray-900 dark:text-white mb-3">
        {t('home.searchResultsCount', { count: resultCount })}
      </h2>
      
      <p className="text-lg text-gray-600 dark:text-gray-400 mb-4">
        {t('home.searchResultsFor')} <span className="font-semibold text-primary-600 dark:text-primary-400 bg-primary-100 dark:bg-primary-900/30 px-3 py-1 rounded-full">"{searchQuery}"</span>
      </p>
      
      {searchTime && (
        <div className="flex items-center justify-center text-sm text-gray-500 dark:text-gray-400">
          <Clock className="w-4 h-4 mr-1" />
          <span>Search completed in {searchTime}ms</span>
        </div>
      )}
      
      {resultCount > 0 && (
        <div className="mt-6 flex items-center justify-center space-x-4 text-sm text-gray-600 dark:text-gray-400">
          <div className="flex items-center">
            <TrendingUp className="w-4 h-4 mr-1 text-green-500" />
            <span>Sorted by relevance</span>
          </div>
        </div>
      )}
    </div>
  );
};
